import * as React from "react";
import { Linking, Text as NativeText } from "react-native";

import { Wrapper, Content, Text, Link } from "./styles";

interface Props {
  isReversed: boolean;
  text: string;
}

const URL_REGEX = /(https?:\/\/[^\s]+)/gi;

export const TextMessage = React.memo<Props>(({ isReversed, text }) => {
  const handleLinkPress = React.useCallback((url: string) => {
    Linking.openURL(url).catch((err) => {
      console.error("Error opening URL:", err);
    });
  }, []);

  const renderText = React.useCallback(() => {
    const parts = text.split(URL_REGEX);
    return parts.map((part, index) => {
      if (part.match(URL_REGEX)) {
        return (
          <Link
            key={index}
            isReversed={isReversed}
            onPress={() => handleLinkPress(part)}
          >
            {part}
          </Link>
        );
      }
      return (
        <Text key={index} isReversed={isReversed}>
          {part}
        </Text>
      );
    });
  }, [text, isReversed, handleLinkPress]);

  return (
    <Wrapper>
      <Content isReversed={isReversed}>
        <NativeText>{renderText()}</NativeText>
      </Content>
    </Wrapper>
  );
});
